import { render, staticRenderFns } from "./hw.editor.vue?vue&type=template&id=504d2936&"
import script from "./hw.editor.vue?vue&type=script&lang=ts&"
export * from "./hw.editor.vue?vue&type=script&lang=ts&"
import style0 from "./hw.editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports